import { CSSProperties } from "react";

export function interpretBoldTags(
  inputString: string,
  fontWeight = 700,
  fontSize: CSSProperties["fontSize"] = "inherit",
  resolvedColor?: string,
) {
  // Regex explains:
  // <b> matches the opening tag
  // (.*?) captures the content inside (lazy match)
  // </b> matches the closing tag
  // 'g' flag ensures all instances are replaced
  const regex = /<b>(.*?)<\/b>/g;

  const color = resolvedColor ?? "inherit";

  return inputString.replace(regex, (_, p1) => {
    return `<span style="font-size: ${fontSize}; font-weight: ${fontWeight}; color: ${color}; ">${p1}</span>`;
  });
}

/**
 * Replaces <b> tags with a <span> that applies a specific color.
 * @param inputString - The raw string containing <b> tags.
 * @param resolvedColor - A resolved CSS color string (e.g., '#FF5A2C', 'rgb(0,0,0)').
 *                        Callers should resolve Chakra theme tokens via useToken before passing.
 * @returns A string with <b> tags replaced by styled <span> tags.
 */
export function interpretColorTags(
  inputString: string,
  resolvedColor: string,
): string {
  // The regex finds <b> tags and captures the inner content
  const regex: RegExp = /<b>(.*?)<\/b>/g;

  return inputString.replace(regex, (_match: string, p1: string): string => {
    // We wrap the captured text (p1) in a span with the color style
    return `<span style="color: ${resolvedColor};">${p1}</span>`;
  });
}
